<script lang="ts" setup>

  const { t } = useI18n()

  // Emits <link rel="canonical"> and the <link rel="alternate" hreflang="..."> set,
  // so Google indexes "/" as Dutch and "/en" as English instead of guessing.
  const localeHead = useLocaleHead({
    addDirAttribute: false,
    addSeoAttributes: true,
  })

  useHead(() => ({
    title: t("company_name"),
    htmlAttrs: {
      lang: localeHead.value.htmlAttrs?.lang,
    },
    link: [
      { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
      ...(localeHead.value.link ?? []),
    ],
    meta: [
      ...(localeHead.value.meta ?? []),
    ],
  }))

</script>

<template>

  <!-- Router View -->
  <main>
    <router-view></router-view>
  </main>

</template>

<style lang="css">

  main {
    width: 100%;
  }

</style>